import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../model/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
  });
  baseUrl: string = environment.backend;

  constructor(private http: HttpClient) { }

  loginUser(userCred): Observable<UserProfile> {
    return this.http.post<UserProfile>(
      this.baseUrl + 'user/authenticate/',
      userCred,
      { headers: this.httpHeaders }
    );
  }
  /*signUpUser(user): Observable<any> {
    return this.http
      .post<any>(this.baseUrl + 'accounts/register/', user)
      .pipe(map((res) => res));
  }*/
  forgetPassword(email): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'api/password_reset/', email);
  }
  resetPassword(password): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'api/password_reset/confirm/',
      password
    );
  }
  checkUserRole(token): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + 'prep_license/check_prep_user/',
      this.getAuthHeaders(token)
    );
  }
  createOnline$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  activationUser(token): Observable<any> {
    return this.http.get(
      this.baseUrl + 'pms_v1/check_user_activation/',
      this.getAuthHeaders1(token)
    );
  }

  private getAuthHeaders(token) {
    const httpHeaders = new HttpHeaders({
      Authorization: 'Token ' + token,
    });
    return { headers: httpHeaders };
  }

  getCheckVersion(): Observable<any> {
    return this.http.get(
      this.baseUrl + 'pms/front_end_version_manager/',

      this.getAuthHeaders2()
    );
  }

  private getAuthHeaders1(token) {
    const httpHeaders = new HttpHeaders({
      Authorization: 'Token ' + token,
    });
    return { headers: httpHeaders };
  }

  private getAuthHeaders2() {
    const token = localStorage.getItem('token');
    const httpHeaders = new HttpHeaders({
      Authorization: 'Token ' + token,
    });
    return { headers: httpHeaders };
  }
}
